<template>
  <ul class="space-y-4 border-b-0">
    <li v-for="item in enhancedItems" :key="item.name">
      <Link
        hover="underline"
        :highlight-active="false"
        :class="{
          'font-bold': item.name === selected,
        }"
        size="base"
        class="px-0 pt-0 tracking-widest"
        :to="item.to"
        @click="onClickItem"
      >
        {{ $t(`sorting_select.${item.name}`) }}
      </Link>
    </li>
  </ul>
</template>

<script setup lang="ts">
import Link from '#layers/base/components/ui/links/AgsLink.vue'
import type { SortValue } from '#layers/base/utils/sort'
import type { OdoscopeSortValue } from '#layers/base/utils/odoscopeSort'

const props = defineProps<{
  items: SortValue[] | OdoscopeSortValue[]
  selected?: string
}>()

const emit = defineEmits(['click:item'])
const route = useRoute()

const { toLocalePath } = useRouteHelpers()

const onClickItem = () => {
  emit('click:item')
}
const enhancedItems = computed(() =>
  props.items.map((item: any) => ({
    ...item,
    to: toLocalePath({
      params: { ...route.params },
      query: { ...route.query, sort: item.query, page: undefined },
    }),
  })),
)
</script>
